import { Navigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { getCommitteeContext } from '@/utils/committeeContext';

/**
 * Component that handles redirect after login, checking for pending committee invites
 */
const LoginRedirect = ({ user }) => {
  const [redirectTo, setRedirectTo] = useState(null);
  const processedRef = useRef(false);
  
  useEffect(() => {
    // Only process once
    if (processedRef.current) {
      return;
    }
    processedRef.current = true;
    
    const pendingInvite = sessionStorage.getItem('pendingCommitteeInvite');
    
    if (pendingInvite) {
      console.log('LoginRedirect: Found pending invite, redirecting to:', pendingInvite);
      sessionStorage.removeItem('pendingCommitteeInvite');
      setRedirectTo(`/committee/join/${pendingInvite}`);
    } else {
      const committeeContext = getCommitteeContext();
      // Redirect based on role
      const routes = {
        admin: '/admin',
        sponsor: '/sponsor',
        chair: '/my-committees',
        co_chair: '/my-committees',
        committee: '/my-committees',
        applicant: '/dashboard'
      };
      let route = routes[user?.role] || '/dashboard';
      if (committeeContext?.slug && user?.role === 'applicant') {
        route = `/${committeeContext.slug}/dashboard`;
      }
      if (committeeContext?.id && ['chair', 'co_chair', 'committee'].includes(user?.role)) {
        route = `/committee-dashboard?committee=${committeeContext.id}`;
      }
      console.log('LoginRedirect: No pending invite, redirecting to:', route);
      setRedirectTo(route);
    }
  }, []); // Empty dependency array - only run once
  
  if (!redirectTo) {
    return null; // Still determining where to redirect
  }
  
  return <Navigate to={redirectTo} replace />;
};

export default LoginRedirect;
